<template>
    <div class="row mx-0 header">
        

        <div class="col-12 text-center text-md-left col-md-3">
            <div class="logo animate__animated animate__fadeIn">
                <img src="../assets/logo.svg">
            </div>
        </div>
        <div class="col-12 col-md-5 offset-md-3 d-flex align-items-center justify-content-center flex-column">
            <h3 class="animate__animated animate__fadeIn text-top">
                Dedicato interamente al mondo della <strong>Pizza fatta in Casa</strong>: guide, ricette, consigli, le vostre creazioni!
            </h3>
            <h4 class="animate__animated animate__fadeIn mt-4 garage-pizza text-bottom">
               Powered by <a href="https://garage.pizza" target="_blank"><strong><img
                        src="https://garage.pizza/wp-content/themes/garagepizza/images/logo-icon.png" style="filter: brightness(0%);"> Garage
                    Pizza</strong></a>
            </h4>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
    margin-bottom: 150px;
}

.logo img {
    margin-top: 10px;
}

.garage-pizza {
    color: #212529;
}

.text-top {
    font-weight: inherit;
    text-align: right;
    font-size: 1.5rem;
    color: #212529;
}

.text-top strong {
    font-size: 1.75rem;
}

.text-bottom {
    font-weight: inherit;
    text-align: right;
    padding-right: 20px;
    font-size: 1.3rem;
}

.text-bottom strong {
    font-size: 1.5rem;
}

.text-bottom img {
    height: 40px;
    margin-top: -15px;
}


@media (max-width: 575.98px) { 

.header {
    background: white;
    margin-bottom: 75px;
    padding: 0 0 20px;
    border-top-right-radius: 0;
    border-radius: 50px;
    border-top-left-radius: 0;
}

.text-top {
    text-align: left;
    margin-top: 20px;
    margin-bottom: 20px;
}

.text-bottom {
    padding-right:0px;
        text-align: center;
}


.logo img {
    width:80%;
}

}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue